module.exports = __webpack_public_path__ + "static/img/Kyle-Feldt.eb61470.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kyle-Feldt.jpg
// module id = usev
// module chunks = 0